import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Claim } from '../models/claim';
import { PersonalInfo } from '../models/personalInfo';
import { HttpService } from './http.service';
// import 'rxjs/Rx'; //fpr localhost test mock response

@Injectable({
  providedIn: 'root'
})

// This class is responsible for API call my information page

export class PersonalInfoService {

  constructor(private httpService: HttpService) { }

  // private apiUrl = environment.apiUrl;
  // private apiUrl = sessionStorage.getItem('apiUrl');
  private uri = '/nihl/api/claim';

   /*
	 * @author Deivid Mafra;
	 * @date 08/13/2020;
	 * @remarks POST service responsible for adding or updating and-user personal info based on body parameters.
   * @param claimId internal claim Id
   * @param data type of PersonalInfo
	 */
  addOrUpdatePersonalInfo = (claimId: number, data: PersonalInfo, token: string): Observable<Claim> => {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    /*  //for localhost test, mock server response
    var claim : Claim = {
        "claimId": 1788,
        "email": "jonathan_li@wsib.on.ca",
        "referenceNumber": "JUI6LSHY",
        "status": "PENDING",
        "creationDate": new Date("2025-04-16T07:36:47"),
        "submitionDate": null,
        "emailWithConsent": "jonathan_li@wsib.on.ca",
        "hasConsentForEmail": true,
        "personalInformation": {
            "personalInfoId": 1773,
            "firstName": "Haiquan",
            "lastName": "Li",
            "dateOfBirth": "1979-09-17",
            "socialInsuranceNumber": "",
            "apartment": "",
            "city": "Thornhill",
            "provinceOrState": "Ontario",
            "postalCode": "L3T 1J3",
            "country": "Canada",
            "emailAddress": "johnli.financial@gmail.com",
            "primaryTelephoneNumber": "(+1) 4163713366",
            "secondaryTelephoneNumber": null,
            "languagePreference": "EN",
            "otherLanguagePreference": "",
            "streetAddress": "211 Grandview Ave"
        },
        "healthCareProviderInformation": null,
        "employmentInformation": null,
        "claimDocumentsList": []
      };
      return Observable.of(claim);
      */
    return this.httpService.post( this.uri + `/${claimId}/personalInfo`, JSON.stringify(data), httpOptions);
  }

}
